import { authUser } from 'src/composables/app/useAuth'
import { PERMISSION_LEVELS } from 'src/services/consts/app.const'

export function hasPermission(level = 'none', userToCheck = null) {
  const user = userToCheck?.value ?? userToCheck ?? authUser.value
  const idx = PERMISSION_LEVELS.indexOf(level)
  if (!user?.id) return false
  const { permissions } = user
  return +permissions[idx] ? true : false
  // 1000000000 - readonly
  // 1100000000 - user
  // 1110000000 - admin
  // 1111000000 - owner(account root)
  // 1110100000 - delete permissions
}

export function refactorUser(user) {
  return {
    id: user.user_id,
    accessToken: user.access_token,
    accessTokenExpires: user.access_token_expires,
    refreshToken: user.refresh_token,
    refreshTokenExpires: user.refresh_token_expires,
    displayName: user.user_display_name,
    permissions: user.user_permissions,
  }
}

// "access_token": "euB91RX8PXsgTu7BShlW",
// "access_token_expires": "Sun, 16 Mar 2025 13:44:09 GMT",
// "refresh_token": "aCwRdrw3BGEqdk7RL0u2",
// "refresh_token_expires": "Tue, 18 Mar 2025 05:44:09 GMT",
// "status": "success",
// "user_display_name": "System Admin",
// "user_id": "usrt0qxd6oaoeNx",
// "user_permissions": "1100000000"
